export default __webpack_public_path__ + "static/media/seemplicity-long.fdda7bb2.svg";